var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 365") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humana-tray-110420",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web_Uber-welcome-tray_v2b-Copy",
    transform: "translate(-33.000000, -686.000000)",
    fill: "#F5426E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-365",
    transform: "translate(33.000000, 686.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.12 12.74 16.41 12.74 17.89 11.26 9.59 11.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.78,6.82 L18.18,0.22 C17.9684896,0.0110775036 17.6524841,-0.0509817719 17.3776709,0.0624332157 C17.1028576,0.175848203 16.9225993,0.442714751 16.92,0.74 C16.9217813,1.45065017 16.6369812,2.13200718 16.13,2.63 L1.43,17.33 C0.546678105,18.1390267 0.030449644,19.2725633 0,20.47 C0.044475333,21.6526167 0.55924009,22.7685403 1.43,23.57 L1.48,23.62 C3.21251976,25.2921514 5.9647183,25.2699204 7.67,23.57 L22.37,8.87 C22.8692762,8.36491766 23.5497995,8.08046611 24.26,8.08 L24.26,8.08 C24.5572852,8.07740069 24.8241518,7.89714239 24.9375668,7.62232915 C25.0509818,7.34751591 24.9889225,7.03151044 24.78,6.82 Z M21.33,7.82 L17.89,11.26 L16.41,12.74 L6.62,22.53 C5.47971777,23.6519864 3.65028223,23.6519864 2.51,22.53 C1.90782856,21.992959 1.54736925,21.2359944 1.51,20.43 C1.5526371,19.6310591 1.91264229,18.8822483 2.51,18.35 L8.16,12.71 L9.63,11.23 L17,3.83 L17.16,3.68 C17.565925,3.26922017 17.8825502,2.77896173 18.09,2.24 L22.74,6.89 C22.2099996,7.09772376 21.7296049,7.4145798 21.33,7.82 L21.33,7.82 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.23,
    cy: 15.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.89,
    cy: 14.48,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.58,
    cy: 16.92,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.01,
    cy: 19.35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.36,
    cy: 20.57,
    r: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.e9f31368a54948ebf4308818296fe2b5.svg";
export { ForwardRef as ReactComponent };